import en from './en'

const translate = {
    en,
}

export default translate
